import { CSSProperties } from "react";

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
const MINUTES = ["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"];

export default function TimeSelect({ value, onChange, disabled }: { value: string; onChange: (v: string) => void; disabled?: boolean }) {
  const [hh, mm] = value.split(":");
  const selectStyle: CSSProperties = {
    padding: "8px 6px", borderRadius: 8, border: "1.5px solid #e5e7eb",
    fontSize: "0.95rem", fontWeight: 700, color: disabled ? "#9ca3af" : "#111827",
    background: disabled ? "#f9fafb" : "#fff", cursor: disabled ? "not-allowed" : "pointer", outline: "none",
    appearance: "none", textAlign: "center", width: "54px",
  };
  // Eski kayıtlarda 5'in katı olmayan dakika olabilir; listede yoksa ekle ki değer kaybolmasın
  const minutes = MINUTES.includes(mm) ? MINUTES : [...MINUTES, mm].sort();
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
      <select value={hh} disabled={disabled} onChange={(e) => onChange(`${e.target.value}:${mm}`)} style={selectStyle} aria-label="Saat">
        {HOURS.map((h) => <option key={h} value={h}>{h}</option>)}
      </select>
      <span style={{ fontWeight: 800, color: "#374151", fontSize: "1rem" }}>:</span>
      <select value={mm} disabled={disabled} onChange={(e) => onChange(`${hh}:${e.target.value}`)} style={selectStyle} aria-label="Dakika">
        {minutes.map((m) => <option key={m} value={m}>{m}</option>)}
      </select>
    </div>
  );
}
